const setTrackDataLayer = ({eventName, custom = {}}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...custom
  });
};

module.exports = function () {
  const elements = document.querySelectorAll('.download-list__list');
  if (elements.length) {
    elements.forEach(el => {
      if (el) {
        const selectAllInput = el.querySelector('.download-list__table-header-item input');
        const allInputs = el.querySelectorAll('.download-list__table-row-item input');
        const downloadSelectedButtons = el.querySelectorAll('.download-list__list .btn');
        const ids = [];
        const endpoint = el.dataset.endpoint;
        const sortNameButton = el.querySelector('.download-list__table-header-item--name');
        const sortDateButton = el.querySelector('.download-list__table-header-item--date');
        const sortTypeButton = el.querySelector('.download-list__table-header-item--type');
        const rows = el.querySelectorAll('.download-list__table-row');
        const disabledRows = el.querySelectorAll('.download-list__table-row--disabled');
        const mediaQuery = window.matchMedia('(max-width: 1024px)');
        const downloadLinks = el.querySelectorAll('.download-list__table-row-item .download-icon');

        let allChecked = false;
        let reversed = true;

        // document.addEventListener('click', (e) => {
        //   disabledRows.forEach(row => {
        //     if (!row.contains(e.target)) {
        //       const tooltip = el.querySelectorAll('.tooltip-text');
        //       tooltip.forEach(item => {
        //         item.classList.remove('tooltip-text--show');
        //       });
        //     }
        //   });
        // });

        if (downloadLinks.length) {
          downloadLinks.forEach(link => {
            link.addEventListener('click', (e) => {
              const target = e.target;
              const docType = target.dataset.doctype;

              const datalayer = {
                eventName: 'document_download',
                custom: {
                  documentDownloadCount: 1,
                  userStatus: el.dataset.userLogin,
                  pageTitle: document.title,
                  [docType]: 1
                }
              };

              setTrackDataLayer(datalayer);
            });
          });
        }

        if (disabledRows.length) {
          disabledRows.forEach(row => {
            row.addEventListener('click', (e) => {
              if (mediaQuery.matches) {
                const tooltip = row.querySelector('.download-list__table-row-title.tooltip .tooltip-text');
                tooltip.classList.add('tooltip-text--show');
                setTooltip(tooltip);
              }
            });
          })
        }

        function setTooltip(tooltip) {
          setTimeout(() => {
            tooltip.classList.remove('tooltip-text--show');
          }, 3000);
        }

        if (sortNameButton) {
          sortNameButton.addEventListener('click', (e) => {
            e.preventDefault();
            cleanReverseClasses();
            if (reversed) {
              sortNameButton.classList.add('download-list__table-header-item--reversed');
            } else {
              sortNameButton.classList.remove('download-list__table-header-item--reversed');
            }
            sortRows('name', reversed);
            reversed = !reversed;

          })
        }

        if (sortDateButton) {
          sortDateButton.addEventListener('click', (e) => {
            e.preventDefault();
            cleanReverseClasses();
            if (reversed) {
              sortDateButton.classList.add('download-list__table-header-item--reversed');
            } else {
              sortDateButton.classList.remove('download-list__table-header-item--reversed');
            }
            sortRows('date', reversed);
            reversed = !reversed;

          })
        }

        if (sortTypeButton) {
          sortTypeButton.addEventListener('click', (e) => {
            e.preventDefault();
            cleanReverseClasses();
            if (reversed) {
              sortTypeButton.classList.add('download-list__table-header-item--reversed');
            } else {
              sortTypeButton.classList.remove('download-list__table-header-item--reversed');
            }
            sortRows('type', reversed);
            reversed = !reversed;
          })
        }

        const cleanReverseClasses = () => {
          sortNameButton.classList.remove('download-list__table-header-item--reversed');
          sortDateButton?.classList.remove('download-list__table-header-item--reversed');
          sortTypeButton.classList.remove('download-list__table-header-item--reversed');
        }

        const sortRows = (type, reversed) => {
          const sortedRows = [...rows].sort((a, b) => {
            const aName = a.querySelector('.row-title').innerText;
            const bName = b.querySelector('.row-title').innerText;
            // const aDate = a.querySelector('.row-date').innerText;
            // const bDate = b.querySelector('.row-date').innerText;
            const aType = a.querySelector('.row-type').innerText;
            const bType = b.querySelector('.row-type').innerText;

            if (type === 'name' && !reversed) {
              if (aName < bName) {
                return -1;
              }
              if (aName > bName) {
                return 1;
              }
              return 0;
            } else if (type === 'name' && reversed) {
              if (aName < bName) {
                return 1;
              }
              if (aName > bName) {
                return -1;
              }
              return 0;
            }

            // if (type === 'date' && !reversed) {
            //   //   sort by date with the following format: MM/DD/YYYY
            //   const aDateArray = aDate.split('/');
            //   const bDateArray = bDate.split('/');
            //   const aDateObj = new Date(aDateArray[2], aDateArray[0], aDateArray[1]);
            //   const bDateObj = new Date(bDateArray[2], bDateArray[0], bDateArray[1]);
            //
            //   if (aDateObj < bDateObj) {
            //     return -1;
            //   }
            //
            //   if (aDateObj > bDateObj) {
            //     return 1;
            //   }
            //   return 0;
            //
            // } else if (type === 'date' && reversed) {
            //   //   sort by date with the following format: MM/DD/YYYY in reverse order
            //   const aDateArray = aDate.split('/');
            //   const bDateArray = bDate.split('/');
            //   const aDateObj = new Date(aDateArray[2], aDateArray[0], aDateArray[1]);
            //   const bDateObj = new Date(bDateArray[2], bDateArray[0], bDateArray[1]);
            //
            //   if (aDateObj < bDateObj) {
            //     return 1;
            //   }
            //
            //   if (aDateObj > bDateObj) {
            //     return -1;
            //   }
            //   return 0;
            // }

            if (type === 'type' && !reversed) {
              if (aType < bType) {
                return -1;
              }
              if (aType > bType) {
                return 1;
              }
              return 0;
            } else if (type === 'type' && reversed) {
              if (aType < bType) {
                return 1;
              }
              if (aType > bType) {
                return -1;
              }
              return 0;
            }
          });

          rows.forEach(row => {
            row.remove();
          });

          sortedRows.forEach(row => {
            el.querySelector('.download-list__table-body').appendChild(row);
          });
        }

        if (selectAllInput) {
          selectAllInput.addEventListener('change', (e) => {
              if (e.target.checked) {
                allInputs.forEach(input => {
                  if (!input.disabled) {
                    input.checked = true;
                    downloadSelectedButtons.forEach(button => {
                      button.classList.remove('btn--disabled');

                    })
                    addId(input.id);
                  }
                })
              } else {
                allInputs.forEach(input => {
                  if (!input.disabled) {
                    input.checked = false;
                    downloadSelectedButtons.forEach(button => {
                      button.classList.add('btn--disabled')
                    });
                    removeId(input.id);
                  }
                })
              }
            }
          )
        }

        if (allInputs.length) {
          allInputs.forEach(input => {
            input.addEventListener('change', (e) => {
              if (!e.target.checked && selectAllInput.checked) {
                selectAllInput.checked = false;
                removeId(input.id);
              }

              if (!e.target.checked) {
                removeId(input.id);
              } else {
                downloadSelectedButtons.forEach(button => {
                  button.classList.add('btn--disabled')
                });
                addId(input.id);
              }

              const onlyEnabledInputs = [...allInputs].filter(input => !input.disabled);
              allChecked = areAllChecked(onlyEnabledInputs);

              if (allChecked) {
                downloadSelectedButtons.forEach(button => {
                  button.classList.remove('btn--disabled');

                })
              } else {
                downloadSelectedButtons.forEach(button => {
                  button.classList.add('btn--disabled')
                });

              }
            });

          })
        }

        if (downloadSelectedButtons.length > 0) {
          downloadSelectedButtons.forEach(button => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              window.open(generateQs(), "_blank");
            })
          });
        }

        const removeId = (id) => {
          if (ids.includes(id)) {
            ids.splice(ids.indexOf(id), 1);
          }
        }

        const addId = (id) => {
          if (!ids.includes(id)) {
            ids.push(id)
          }
        }

        const areAllChecked = (inputs) => {
          return inputs.some(item => item.checked === true);
        }

        const generateQs = () => {
          const anchors = el.querySelectorAll('a[data-doctype]');
          const docTypes = [...anchors].map((a) => a.dataset.doctype);
          const docTypesSet = new Set(docTypes);
          const docTypesArray = [...docTypesSet];
          const docTypesCount = docTypesArray.map(type => docTypes.filter(item => item === type).length);
          const docTypesObject = docTypesArray.map((type, i) => ({[type]: docTypesCount[i]}))

          const custom = {
            documentDownloadCount: ids.length,
            userStatus: el.dataset.userLogin,
            pageTitle: document.title,
          }

          Object.assign(custom, ...docTypesObject);

          const datalayer = {
            eventName: 'document_download',
            custom
          };

          setTrackDataLayer(datalayer);

          const qsIds = ids.map((id, i) => i === 0 ? `fields=${id}` : `&fields=${id}`);
          return `${endpoint}?${qsIds.join('')}`;
        }
      }
    });
  }
};

